import React, { Component } from 'react';
import Select from '../../../shared/select';

const STORAGE_KEY = 'TimeZoneSelect.lastSelected';

class TimeZoneSelect extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  static getLastSelected() {
    try {
      return localStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  static setLastSelected(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (error) {
      /* ... */
    }
  }

  handleChange(e) {
    const timeZoneName = e.target.value;
    const timeZoneOffSet = this.props.timeZones.find(
      ({ name }) => timeZoneName === name,
    )?.offset;
    this.props.onChange(timeZoneName, timeZoneOffSet, this.props.id);
  }

  render() {
    const { className, value, name, timeZones, disabled } = this.props;
    return (
      <div className={className}>
        <label className="d-b" htmlFor="Time Zone">
          {t('common.time_zone')} *
        </label>
        <Select
          ariaLabel={t('common.time_zone')}
          onChange={this.handleChange}
          value={value}
          name={name}
          disabled={disabled}
          fullWidth
          ariaRequired="true"
        >
          <option disabled value="">
            {t('common.time_zone_empty')}
          </option>
          {timeZones.map(tz => (
            <option key={tz.name} value={tz.name}>
              {tz.formatted}
            </option>
          ))}
        </Select>
      </div>
    );
  }
}

export default TimeZoneSelect;
